<app-dashboard-layout
  [notDashboard]="true"
  [loading]="loading || skeletonLoader"
>
  <section class="bg-white border rounded-md p-4">
    <header class="border-b flex text-lg mb-6 w-full pb-4 gap-8 md:text-xl">
      Medical History
    </header>

    <div
      *ngIf="skeletonLoader"
      class="max-w-screen-md grid pb-4 gap-4 grid-cols-1 md:gap-8 md:grid-cols-2"
    >
      <div
        *ngFor="let i of [1, 2, 3, 4, 5, 6, 7, 8]"
        class="border rounded-md bg-gray-300 h-20 animate-pulse"
      ></div>
    </div>

    <form
      ngNativeValidate
      *ngIf="!skeletonLoader"
      id="biodata-medical-history"
      (ngSubmit)="updateMedicalHistory()"
      class="max-w-screen-md grid gap-8 grid-cols-1"
    >
      <app-notification-alert [data]="notification"></app-notification-alert>

      <section class="grid gap-8 grid-cols-1 md:gap-8 md:grid-cols-2">
        <label class="block">
          <div class="font-medium text-grey-darker text-sm pb-2">
            Are you Immunized Against Tetanus?
          </div>

          <div
            class="border border-primary-lighter rounded flex text-sm w-full py-2 px-3 text-gray-700 justify-between items-center appearance-none focus:outline-none focus-within:border-primary-light"
          >
            <div>{{ payload.ImmunizeAgainstTetanusLabel }}</div>
            <input
              type="checkbox"
              [checked]="payload.ImmunizeAgainstTetanus"
              name="ImmunizeAgainstTetanus"
              (change)="toggleCheckBox('ImmunizeAgainstTetanus')"
            />
          </div>
        </label>

        <label class="block">
          <div class="font-medium text-grey-darker text-sm pb-2">
            Are you Immunized Against Small Pox?
          </div>

          <div
            class="border border-primary-lighter rounded flex text-sm w-full py-2 px-3 text-gray-700 justify-between items-center appearance-none focus:outline-none focus-within:border-primary-light"
          >
            <div>{{ payload.ImmunizeAgainstSmallPoxLabel }}</div>
            <input
              type="checkbox"
              [checked]="payload.ImmunizeAgainstSmallPox"
              name="ImmunizeAgainstSmallPox"
              (change)="toggleCheckBox('ImmunizeAgainstSmallPox')"
            />
          </div>
        </label>

        <label class="block">
          <div class="font-medium text-grey-darker text-sm pb-2">
            Are you Immunized Against Diptheria?
          </div>

          <div
            class="border border-primary-lighter rounded flex text-sm w-full py-2 px-3 text-gray-700 justify-between items-center appearance-none focus:outline-none focus-within:border-primary-light"
          >
            <div>{{ payload.ImmunizeAgainstDiptheriaLabel }}</div>
            <input
              type="checkbox"
              [checked]="payload.ImmunizeAgainstDiptheria"
              name="ImmunizeAgainstDiptheria"
              (change)="toggleCheckBox('ImmunizeAgainstDiptheria')"
            />
          </div>
        </label>

        <label class="block">
          <div class="font-medium text-grey-darker text-sm pb-2">
            Allergies
          </div>
          <input
            type="text"
            name="ChildAllergy"
            placeholder="Allergies"
            [(ngModel)]="payload.ChildAllergy"
            class="border border-primary-lighter rounded text-sm w-full py-2 px-3 text-gray-700 appearance-none focus:outline-none focus-within:border-primary-light"
          />
        </label>

        <label class="block">
          <div class="font-medium text-grey-darker text-sm pb-2">
            Unusual Diseases
          </div>
          <input
            type="text"
            name="Unusual Diseases"
            placeholder="UnusualDisease"
            [(ngModel)]="payload.UnusualDisease"
            class="border border-primary-lighter rounded text-sm w-full py-2 px-3 text-gray-700 appearance-none focus:outline-none focus-within:border-primary-light"
          />
        </label>

        <label class="block">
          <div class="font-medium text-grey-darker text-sm pb-2">
            Special Drugs
          </div>
          <input
            type="text"
            name="SpecialDrug"
            placeholder="Special Drugs"
            [(ngModel)]="payload.SpecialDrug"
            class="border border-primary-lighter rounded text-sm w-full py-2 px-3 text-gray-700 appearance-none focus:outline-none focus-within:border-primary-light"
          />
        </label>

        <label class="block">
          <div class="font-medium text-grey-darker text-sm pb-2">
            Other Health Issues
          </div>
          <input
            type="text"
            name="HealthIssue"
            placeholder="Other Health Issues"
            [(ngModel)]="payload.HealthIssue"
            class="border border-primary-lighter rounded text-sm w-full py-2 px-3 text-gray-700 appearance-none focus:outline-none focus-within:border-primary-light"
          />
        </label>

        <label class="block">
          <div class="font-medium text-grey-darker text-sm pb-2">
            Height (in cm)
          </div>
          <input
            type="number"
            step=".01"
            name="Height"
            [(ngModel)]="payload.Height"
            class="border border-primary-lighter rounded text-sm w-full py-2 px-3 text-gray-700 appearance-none focus:outline-none focus-within:border-primary-light"
          />
        </label>

        <label class="block">
          <div class="font-medium text-grey-darker text-sm pb-2">
            Weight (in kg)
          </div>
          <input
            type="number"
            step=".01"
            name="Weight"
            [(ngModel)]="payload.Weight"
            class="border border-primary-lighter rounded text-sm w-full py-2 px-3 text-gray-700 appearance-none focus:outline-none focus-within:border-primary-light"
          />
        </label>
      </section>

      <nav class="flex flex-col py-6 gap-4 justify-center">
        <app-button-primary
          type="submit"
          [disabled]="loading"
          class="mx-auto max-w-screen-sm w-full"
        >
          UPDATE MEDICAL HISTORY
        </app-button-primary>

        <app-notification-alert [data]="notification"></app-notification-alert>
      </nav>
    </form>
  </section>
</app-dashboard-layout>
